import React from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { useCart } from '../../contexts/CartContext';

export default function CartIcon({ onClick }) {
  const { getTotalItems } = useCart();
  const totalItems = getTotalItems();

  return (
    <button
      onClick={onClick}
      className="relative flex items-center justify-center w-10 h-10 bg-df-surface border border-df-border hover:border-df-accent text-df-muted hover:text-df-accent rounded-full transition-all duration-200"
    >
      <FaShoppingCart className="text-lg" />
      {totalItems > 0 && (
        <span className="absolute -top-2 -right-2 bg-df-accent-strong text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center min-w-[1.25rem]">
          {totalItems > 99 ? '99+' : totalItems}
        </span>
      )}
    </button>
  );
}
